import React from "react";

export default function TransparencyPreview({ src, alt }) {
  return (
    <div
      className="overflow-hidden rounded-2xl border border-white/10 bg-zinc-950/40"
      data-testid="transparency-preview-wrapper"
    >
      <div
        className="h-64 w-full"
        style={{
          backgroundImage:
            "linear-gradient(45deg, rgba(255,255,255,0.08) 25%, transparent 25%), linear-gradient(-45deg, rgba(255,255,255,0.08) 25%, transparent 25%), linear-gradient(45deg, transparent 75%, rgba(255,255,255,0.08) 75%), linear-gradient(-45deg, transparent 75%, rgba(255,255,255,0.08) 75%)",
          backgroundSize: "28px 28px",
          backgroundPosition: "0 0, 0 14px, 14px -14px, -14px 0px",
        }}
      >
        {src ? (
          <img
            src={src}
            alt={alt}
            className="h-full w-full object-contain"
            data-testid="transparency-preview-image"
          />
        ) : (
          <div
            className="grid h-full place-items-center text-sm text-zinc-400"
            data-testid="transparency-preview-empty"
          >
            Output preview will appear here
          </div>
        )}
      </div>
    </div>
  );
}
